import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { authFetchBaseQuery, baseUrl, CLOUD_FETCH_TIMEOUT } from './apiConfig';
import { ResponseBase } from './request';

const baseEndpointUrl = `${baseUrl}`;
const apiPrefix = 'properties/units';

export interface Unit {
  id: string;
  name: string;
  unit_type: string;
  property_id: string;
  building_id: string;
  physical_location: string;
  updatedAt: string;
  createdAt: string;
}

interface GetUnitResponse extends ResponseBase {
  data: Unit;
}

export interface GetUnitRequest {
  unitId: string;
}

export const unitsApi = createApi({
  reducerPath: 'unitsApi',
  baseQuery: authFetchBaseQuery({
    baseUrl: baseEndpointUrl,
  }),
  endpoints: (builder) => ({
    getUnit: builder.query<Unit, GetUnitRequest>({
      query: ({ unitId }) => ({ url: `${apiPrefix}/${unitId}`, timeout: CLOUD_FETCH_TIMEOUT }),
      transformResponse: (response: GetUnitResponse) => response.data,
    }),
  }),
});

export const { useGetUnitQuery, useLazyGetUnitQuery } = unitsApi;
